import React from 'react';
import { useGame } from '../context/GameContext';

export const HUD: React.FC = () => {
  const { state } = useGame();
  const { 
    currentNumber, 
    errors, 
    timeElapsed,
    difficulty,
    selectedCells,
    grid,
    obstacles
  } = state;

  const totalNumbers = grid.flat().filter(n => n > 0).length;
  const progress = selectedCells.length;
  const accuracyPct = totalNumbers > 0 
    ? ((progress / (progress + errors)) * 100).toFixed(1)
    : '100.0';

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="bg-white p-3 sm:p-4 rounded-lg shadow-md space-y-3 sm:space-y-4">
      <div className="text-center">
        <span className="text-base sm:text-lg font-semibold">Next Number:</span>
        <span className="ml-2 text-xl sm:text-2xl text-blue-600">{currentNumber}</span>
      </div>

      <div className="space-y-1 sm:space-y-2">
        <div className="flex justify-between text-sm sm:text-base">
          <span>Time:</span>
          <span className="font-mono">{formatTime(timeElapsed)}</span>
        </div>

        <div className="flex justify-between text-sm sm:text-base">
          <span>Errors:</span>
          <span className="text-red-500">{errors}</span>
        </div>

        <div className="flex justify-between text-sm sm:text-base">
          <span>Accuracy:</span>
          <span>{accuracyPct}%</span>
        </div>

        <div className="flex justify-between text-sm sm:text-base">
          <span>Progress:</span>
          <span>{progress} / {totalNumbers}</span>
        </div>
      </div>

      <div className="pt-3 sm:pt-4 border-t">
        <h3 className="text-center font-semibold mb-2 text-sm sm:text-base">Difficulty</h3>
        <div className="flex justify-between text-xs sm:text-sm">
          <span>Grid Size:</span>
          <span>{difficulty.gridSize}×{difficulty.gridSize}</span>
        </div>
        <div className="flex justify-between text-xs sm:text-sm">
          <span>Obstacles:</span>
          <span>{difficulty.obstaclesCount}</span>
        </div>
        <div className="flex justify-between text-xs sm:text-sm">
          <span>Hints:</span>
          <span>{difficulty.showHints ? 'Enabled' : 'Disabled'}</span>
        </div>
      </div>
    </div>
  );
};